import React from 'react';
import { FilterChip } from './FilterChip';
import { IFilterChipGroupProps } from './types';

const RESERVED_ALL_VALUE = 'all';

export const FilterChipGroup: React.FC<IFilterChipGroupProps> = ({ label, options, selectedValues, onChange }) => {
  const handleChipClick = (value: string) => {
    if (value === RESERVED_ALL_VALUE) {
      // Clicking "All" clears all selections
      onChange([]);
    } else {
      // Clicking a specific chip
      if (selectedValues.includes(value)) {
        // Deselect this chip
        const newValues = selectedValues.filter(v => v !== value);
        // If all chips deselected, automatically select "All" (empty array)
        onChange(newValues);
      } else {
        // Select this chip (automatically deselects "All")
        onChange([...selectedValues, value]);
      }
    }
  };

  // "All" is selected when selectedValues is empty
  const isAllSelected = selectedValues.length === 0;

  return (
    <div className="flex flex-col">
      {label && (
        <span className="block font-hurmegeometric-sans text-[13px] leading-[1.272] uppercase text-black tracking-wider mb-[10px]">
          {label}
        </span>
      )}
      <div className="flex flex-row gap-[10px] flex-wrap">
        {/* "All" badge */}
        <FilterChip label="All" isSelected={isAllSelected} onClick={() => handleChipClick(RESERVED_ALL_VALUE)} />

        {/* Specific option badges */}
        {options.map(option => (
          <FilterChip
            key={option.value}
            label={option.label}
            isSelected={selectedValues.includes(option.value)}
            onClick={() => handleChipClick(option.value)}
          />
        ))}
      </div>
    </div>
  );
};
